import type { RealtimeEventData } from "@birdwatch/common";

/** The platform announces its `ENV_DEPLOY`; the app knows itself by `PUBLIC_ENV`. */
const DEPLOY_ENV_TO_APP_ENV = {
  dev: "development",
  staging: "staging",
  beta: "beta",
  prod: "main",
} as const;

type DeployEnv = keyof typeof DEPLOY_ENV_TO_APP_ENV;

type AppEnv = (typeof DEPLOY_ENV_TO_APP_ENV)[DeployEnv];

/** The app name a release of this webapp carries. */
const WEBAPP_APP = "unified-webapp";

function isDeployEnv(value: string): value is DeployEnv {
  return Object.hasOwn(DEPLOY_ENV_TO_APP_ENV, value);
}

/**
 * The app environment an `app.released` announces a new build of this webapp for, or
 * `null` for another app's release.
 *
 * An unknown `environment` is dropped rather than defaulted — announcing a deploy of the
 * wrong environment is worse than announcing nothing.
 */
export function releasedWebappEnv({
  app,
  environment,
}: RealtimeEventData<"app.released">): AppEnv | null {
  if (app !== WEBAPP_APP || !isDeployEnv(environment)) return null;
  return DEPLOY_ENV_TO_APP_ENV[environment];
}
